import React, { useEffect } from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import {
  FaChartBar,
  FaUtensils,
  FaBed,
  FaFileAlt,
  FaArrowLeft,
  FaUserTie,
  FaHistory,
  FaCalendarAlt,
  FaMoneyBillWave,
  FaExchangeAlt,
} from 'react-icons/fa';

const ReportesIndex = () => {
  const navigate = useNavigate();
  const token = localStorage.getItem("token");
  const currentUser = JSON.parse(localStorage.getItem("user"));

  // Redirect if not authenticated
  useEffect(() => {
    if (!token || !currentUser) {
      navigate("/");
    }
  }, [navigate, token, currentUser]);

  // Configuración de reportes disponibles
  const reportes = [
    {
      id: 'atencion-comedor',
      title: 'Reporte de Atención por Comedor',
      description: 'Análisis detallado de atención y consumo por comedor',
      icon: <FaChartBar size={48} />,
      path: '/reportes/alimentacion/atencion-por-comedor',
      color: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      iconColor: '#667eea'
    },
    {
      id: 'comensales-comedor',
      title: 'Reporte de Comensales por Comedor',
      description: 'Listado completo de comensales por comedor',
      icon: <FaFileAlt size={48} />,
      path: '/reportes/alimentacion/comensales-por-comedor',
      color: 'linear-gradient(135deg, #11998e 0%, #38ef7d 100%)',
      iconColor: '#11998e'
    },
    {
      id: 'consulta-atenciones',
      title: 'Consulta de Atenciones por Comensal',
      description: 'Búsqueda de servicios por número de documento',
      icon: <FaFileAlt size={48} />,
      path: '/reportes/alimentacion/consulta-atenciones-comensales',
      color: 'linear-gradient(135deg, #9c88ff 0%, #6a4c93 100%)',
      iconColor: '#9c88ff'
    },
    {
      id: 'consolidado-consumos',
      title: 'Consolidado de Consumos por Comensal',
      description: 'Reporte actual (servidor Laravel)',
      icon: <FaChartBar size={48} />,
      path: '/reporte-consolidado-consumos',
      color: 'linear-gradient(135deg, #00c6ff 0%, #0072ff 100%)',
      iconColor: '#00c6ff'
    },
    {
      id: 'consolidado-consumos-campamento',
      title: 'Consolidado de Consumos por Comensal (Campamento)',
      description: 'Misma lógica vía API Campamento (FastAPI); no sustituye al reporte Laravel',
      icon: <FaChartBar size={48} />,
      path: '/reportes/alimentacion/consolidado-consumos-comensal',
      color: 'linear-gradient(135deg, #11998e 0%, #38ef7d 100%)',
      iconColor: '#11998e'
    },
    {
      id: 'consolidado-consumos-fechas',
      title: 'Consolidado de Consumos por Fechas',
      description: 'Reporte de totales de consumos organizados por fechas',
      icon: <FaFileAlt size={48} />,
      path: '/reporte-consolidado-consumos-fechas',
      color: 'linear-gradient(135deg, #ff6b6b 0%, #ee5a24 100%)',
      iconColor: '#ff6b6b'
    },
    {
      id: 'comensales-dietas',
      title: 'Comensales con Dietas',
      description: 'Reporte de comensales con dietas asignadas por cliente',
      icon: <FaChartBar size={48} />,
      path: '/reportes/alimentacion/comensales-dietas',
      color: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
      iconColor: '#f093fb'
    },
    {
      id: 'servicios-duplicados-comensales',
      title: 'Servicios duplicados comensales',
      description: 'Comensales que consumieron el mismo servicio en varios comedores el mismo día',
      icon: <FaFileAlt size={48} />,
      path: '/reportes/alimentacion/servicios-duplicados-comensales',
      color: 'linear-gradient(135deg, #eb3349 0%, #f45c43 100%)',
      iconColor: '#eb3349'
    },
    {
      id: 'menus-ciclicos',
      title: 'Menús Cíclicos',
      description: 'Reporte completo de menús cíclicos con detalles de semanas y recetas',
      icon: <FaUtensils size={48} />,
      path: '/reporte-menus-ciclicos',
      color: 'linear-gradient(135deg, #fa709a 0%, #fee140 100%)',
      iconColor: '#fa709a'
    },
    {
      id: 'reporte-ocupabilidad',
      title: 'Reporte de Ocupabilidad',
      description: 'Detalle de ocupabilidad por trabajador, módulo, habitación y cama (reservado/ocupado).',
      icon: <FaHistory size={48} />,
      path: '/reportes/hoteleria/reporte-ocupabilidad',
      color: 'linear-gradient(135deg, #a770ef 0%, #cf8bf3 100%)',
      iconColor: '#a770ef'
    },
    {
      id: 'reporte-trabajadores',
      title: 'Reporte de Trabajadores',
      description: 'Reporte de trabajadores por proyecto',
      icon: <FaUserTie size={48} />,
      path: '/reportes/hoteleria/trabajadores',
      color: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
      iconColor: '#4facfe'
    },
    {
      id: 'camas-hoteleria',
      title: 'Reporte de Camas',
      description: 'Reporte detallado de camas, estados y ocupación',
      icon: <FaBed size={48} />,
      path: '/reportes/hoteleria/camas',
      color: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      iconColor: '#667eea'
    },
    {
      id: 'reservas-hoteleria',
      title: 'Reporte de Reservas',
      description: 'Reservas con filtro activas/no activas y días desde la fecha de reserva (Perú).',
      icon: <FaCalendarAlt size={48} />,
      path: '/reportes/hoteleria/reservas',
      color: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)',
      iconColor: '#f59e0b'
    },
    {
      id: 'modificaciones-reservas-hoteleria',
      title: 'Modificaciones de reservas',
      description:
        'Historial de cambios de fechas de entrada/salida (adelantos de llegada, etc.) con fecha del cambio y motivo.',
      icon: <FaExchangeAlt size={48} />,
      path: '/reportes/hoteleria/modificaciones-reservas',
      color: 'linear-gradient(135deg, #8b5cf6 0%, #6d28d9 100%)',
      iconColor: '#8b5cf6'
    },
    {
      id: 'habitabilidad-hoteleria',
      title: 'Reporte de Habitabilidad',
      description: 'Ocupación del campamento: camas habilitadas, ocupadas y libres por módulo y género.',
      icon: <FaChartBar size={48} />,
      path: '/reportes/hoteleria/habitabilidad',
      color: 'linear-gradient(135deg, #002060 0%, #1e40af 100%)',
      iconColor: '#002060'
    },
    {
      id: 'valorizacion-hoteleria',
      title: 'Valorización Hotelería',
      description: 'Hombre/día por servicio (STAFF/WORKER/módulos), costos e IGV. Excel con VALORIZACION, RESUMEN, DETALLES.',
      icon: <FaMoneyBillWave size={48} />,
      path: '/reportes/hoteleria/valorizacion',
      color: 'linear-gradient(135deg, #11998e 0%, #38ef7d 100%)',
      iconColor: '#11998e'
    },
    {
      id: 'historial-huesped-hoteleria',
      title: 'Historial de huéspedes',
      description: 'Estadías de todos los DNI del proyecto: reserva, check-in, check-out, habitación y cama. Exporta a Excel.',
      icon: <FaHistory size={48} />,
      path: '/reportes/hoteleria/historial-huesped',
      color: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      iconColor: '#667eea'
    },
    {
      id: 'depositos-corporativo',
      title: 'Depósitos Corporativo',
      description: 'Reportes detallado en Excel y agrupado en PDF por centro de costo y tipo de depósito.',
      icon: <FaMoneyBillWave size={48} />,
      path: '/reportes/corporativo/depositos',
      color: 'linear-gradient(135deg, #0f766e 0%, #14b8a6 100%)',
      iconColor: '#14b8a6'
    }
  ];

  const handleReportClick = (path) => {
    navigate(path);
  };

  const handleBackToHome = () => {
    navigate("/home");
  };

  return (
    <>
      {/* Digital Harmony Styles para Índice de Reportes */}
      <style>
        {`
        .dh-reports-bg {
          background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
          min-height: 100vh;
        }
        
        .dh-main-header {
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          color: white;
          padding: 2rem 0;
          margin-bottom: 2rem;
          border-radius: 0 0 30px 30px;
          box-shadow: 0 10px 30px rgba(102, 126, 234, 0.2);
        }
        
        .dh-main-title {
          font-size: 2.5rem;
          font-weight: 700;
          margin: 0;
        }
        
        .dh-main-subtitle {
          font-size: 1.1rem;
          opacity: 0.9;
          margin: 0.5rem 0 0 0;
        }
        
        .dh-report-card {
          border: none;
          border-radius: 20px;
          box-shadow: 0 15px 35px rgba(0, 0, 0, 0.1);
          background: white;
          transition: all 0.3s ease;
          cursor: pointer;
          height: 100%;
          overflow: hidden;
          position: relative;
        }
        
        .dh-report-card:hover {
          transform: translateY(-10px);
          box-shadow: 0 25px 50px rgba(0, 0, 0, 0.15);
        }
        
        .dh-report-card::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          height: 5px;
          background: var(--card-gradient);
        }
        
        .dh-report-icon {
          width: 100px;
          height: 100px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto 1.5rem;
          background: var(--card-gradient);
          color: white;
          box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
        }
        
        .dh-report-title {
          font-size: 1.5rem;
          font-weight: 700;
          color: #2d3748;
          margin-bottom: 1rem;
          text-align: center;
        }
        
        .dh-report-description {
          color: #718096;
          text-align: center;
          line-height: 1.6;
          margin-bottom: 1.5rem;
        }
        
        .dh-report-footer {
          background: #f8f9fa;
          padding: 1rem;
          text-align: center;
          margin-top: auto;
          font-weight: 600;
          color: #4a5568;
        }
        
        .btn-dh-back {
          background: linear-gradient(135deg, #6b7280 0%, #374151 100%);
          border: none;
          color: white;
          border-radius: 12px;
          padding: 12px 20px;
          font-weight: 600;
          box-shadow: 0 4px 14px rgba(107, 114, 128, 0.3);
          transition: all 0.3s ease;
        }
        
        .btn-dh-back:hover {
          background: linear-gradient(135deg, #374151 0%, #1f2937 100%);
          transform: translateY(-2px);
          box-shadow: 0 8px 25px rgba(107, 114, 128, 0.4);
          color: white;
        }
        
        .dh-stats-card {
          background: rgba(255, 255, 255, 0.9);
          border: none;
          border-radius: 15px;
          padding: 1.5rem;
          text-align: center;
          box-shadow: 0 5px 15px rgba(0, 0, 0, 0.08);
        }
        
        .dh-stats-number {
          font-size: 2.5rem;
          font-weight: 800;
          margin: 0;
        }
        
        .dh-stats-label {
          color: #718096;
          font-size: 0.9rem;
          margin: 0;
        }
        `}
      </style>

      <div className="dh-reports-bg">
        <div className="dh-main-header">
          <Container>
            <div className="d-flex justify-content-between align-items-center">
              <div>
                <h1 className="dh-main-title">
                  <FaChartBar className="me-3" />
                  Reportes del Sistema
                </h1>
                <p className="dh-main-subtitle">Selecciona el reporte que necesitas generar</p>
              </div>
              <button
                className="btn-dh-back d-flex align-items-center"
                onClick={handleBackToHome}
              >
                <FaArrowLeft className="me-2" />
                Volver al Inicio
              </button>
            </div>
          </Container>
        </div>

        <Container className="py-4">
          {/* Estadísticas rápidas */}
          <Row className="mb-5">
            <Col md={4}>
              <div className="dh-stats-card">
                <h3 className="dh-stats-number text-primary">{reportes.length}</h3>
                <p className="dh-stats-label">Reportes Disponibles</p>
              </div>
            </Col>
            <Col md={4}>
              <div className="dh-stats-card">
                <h3 className="dh-stats-number text-success">3</h3>
                <p className="dh-stats-label">Categorías</p>
              </div>
            </Col>
            <Col md={4}>
              <div className="dh-stats-card">
                <h3 className="dh-stats-number text-info">Excel</h3>
                <p className="dh-stats-label">Formato de Descarga</p>
              </div>
            </Col>
          </Row>

          {/* Grid de reportes */}
          <Row>
            {reportes.map((reporte) => (
              <Col lg={4} md={6} className="mb-4" key={reporte.id}>
                <Card
                  className="dh-report-card"
                  onClick={() => handleReportClick(reporte.path)}
                  style={{ '--card-gradient': reporte.color }}
                >
                  <Card.Body className="d-flex flex-column text-center p-4">
                    <div
                      className="dh-report-icon"
                      style={{ '--card-gradient': reporte.color }}
                    >
                      {reporte.icon}
                    </div>

                    <h4 className="dh-report-title">
                      {reporte.title}
                    </h4>

                    <p className="dh-report-description">
                      {reporte.description}
                    </p>
                  </Card.Body>

                  <div className="dh-report-footer">
                    Hacer clic para generar reporte
                  </div>
                </Card>
              </Col>
            ))}
          </Row>

          {/* Información adicional */}
          <Row className="mt-5">
            <Col>
              <Card className="dh-report-card" style={{ cursor: 'default' }}>
                <Card.Body className="text-center p-4">
                  <h5 className="mb-3" style={{ color: '#4a5568' }}>
                    💡 Información sobre los Reportes
                  </h5>
                  <Row>
                    <Col md={4}>
                      <div className="mb-3">
                        <FaChartBar size={24} className="text-primary mb-2" />
                        <h6>Reportes Analíticos</h6>
                        <small className="text-muted">
                          Análisis detallados con gráficos y estadísticas
                        </small>
                      </div>
                    </Col>
                    <Col md={4}>
                      <div className="mb-3">
                        <FaFileAlt size={24} className="text-success mb-2" />
                        <h6>Reportes de Datos</h6>
                        <small className="text-muted">
                          Listados completos de información del sistema
                        </small>
                      </div>
                    </Col>
                    <Col md={4}>
                      <div className="mb-3">
                        <FaChartBar size={24} className="text-info mb-2" />
                        <h6>Reportes Consolidados</h6>
                        <small className="text-muted">
                          Resúmenes ejecutivos por períodos de tiempo
                        </small>
                      </div>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default ReportesIndex;